<template>
    <!-- 对话框 -->
    <el-drawer title="添加优惠卡" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="600px">
        <!-- 基本信息表单 -->
        <div class="form-box">
            <template>
                <el-form ref="form" :model="submit_data" label-width="80px">
                    <el-form-item label="优惠卡名字:" label-width="120px">
                        <el-input
                            v-model="submit_data.name"
                            :placeholder="submit_rules.name.placeholder"
                            style="width: 300px; margin-right: 5px"
                        >
                        </el-input>
                    </el-form-item>
                    <el-form-item label="优惠卡金额:" label-width="120px">
                        <el-input
                            v-model="submit_data.amount"
                            :placeholder="submit_rules.amount.placeholder"
                            style="width: 300px; margin-right: 5px"
                        >
                        </el-input>
                    </el-form-item>
                    <el-form-item label="线下支付:" label-width="120px">
                        <el-radio-group v-model="submit_data.offline_pay">
                            <el-radio label="1">开启</el-radio>
                            <el-radio label="0">关闭</el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="订单模式:" label-width="120px">
                        <el-checkbox-group v-model="order_mode">
                            <el-checkbox
                                v-for="(item, index) in options_order_code"
                                :label="item.order_mode.order_mode_code"
                                border
                                style="margin: 5px"
                                :key="index"
                            >
                                {{ item.name }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="有效期:" label-width="120px">
                        <el-radio-group v-model="submit_data.is_open">
                            <el-radio label="1">开启</el-radio>
                            <el-radio label="0">关闭</el-radio>
                        </el-radio-group>
                        <el-tooltip class="item" effect="dark" content="关闭后优惠卡永久有效" placement="right">
                            <i class="el-icon-question"></i>
                        </el-tooltip>

                    </el-form-item>
                    <el-form-item label="过期时间:" label-width="120px" v-if="submit_data.is_open =='1'">
                        <el-date-picker
                            v-model="submit_data.end_time"
                            type="datetime"
                            placeholder="选择时间"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :picker-options="pickerOptions1"
                            style="width:300px"
                        >
                        </el-date-picker>
                    </el-form-item>

                    <el-form-item label="优惠卡数量:" label-width="120px">
                        <el-input
                            v-model="submit_data.num"
                            :placeholder="submit_rules.num.placeholder"
                            style="width: 300px; margin-right: 5px"
                        >
                        </el-input>
                        <el-tooltip class="item" effect="dark" content="一次性最多50个" placement="right">
                            <i class="el-icon-question"></i>
                        </el-tooltip>

                    </el-form-item>
                </el-form>

                <!-- 对话框底部按钮 -->
                <div style="display: flex; justify-content: center;margin-top:50px">
                    <submitBtn
                        @onSubmitDig="onSubmitDig"
                        :data="submit_data"
                        :rules="submit_rules"
                        :url="submit_url"
                        :JSON_Boolean="true"
                        @toJSON="toJSON"
                    ></submitBtn>
                    <el-button @click="closeDialog">关闭</el-button>
                </div>
            </template>
        </div>
    </el-drawer>
</template>

<script>
var _this;
export default {
    props: {
        isShow: Boolean
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;
            _this.orderModeList();
        }
    },
    data() {
        return {
            pickerOptions1: {
                disabledDate(time) {

                    var thatDay = time.getTime();

                    return thatDay < Date.now();
                }
            },
            show: false,
            // 选中订单模式
            order_mode: [],

            //订单模式数据
            options_order_code: [],

            mode_options_data: {
                page: 1,
                limit: 50,
                status: '1'
            },
            submit_url: '/offlinediscountcard/addofflineDiscountCardSub',
            // 表单数据
            submit_data: {
                name: '',
                amount: '',
                offline_pay: '',
                order_mode: '',
                end_time: '',
                num: ''
            },

            submit_rules: {
                name: {
                    placeholder: '优惠卡名字',
                    rules: {
                        required: true,
                        message: '优惠卡名字错误',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                amount: {
                    placeholder: '优惠卡金额',
                    rules: {
                        required: true,
                        message: '优惠卡金额为0-999.9的数字',
                        regulation: 'between',
                        rulesData: [0, 999.9]
                    }
                },
                offline_pay: {
                    placeholder: '线下支付',
                    rules: {
                        required: true,
                        message: '线下支付错误',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                order_mode: {
                    placeholder: '订单模式',
                    rules: {
                        required: true,
                        message: '订单模式错误',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                is_open: {
                    placeholder: '有效期',
                    rules: {
                        required: true,
                        message: '有效期错误',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                end_time: {
                    placeholder: '过期时间',
                    rules: {
                        required: true,
                        message: '过期时间错误',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                num: {
                    placeholder: '优惠卡数量',
                    rules: {
                        required: true,
                        message: '优惠卡数量不超过50的数字',
                        regulation: 'between_int',
                        rulesData: [1, 50]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
    },
    methods: {
        toJSON() {

            if(_this.submit_data.is_open == 0) {
                _this.submit_rules.end_time.rules.required = false;
                _this.submit_data.end_time= '';

            }

            if (_this.order_mode.length!=0) {
                _this.submit_data.order_mode = JSON.stringify(_this.order_mode);
            }else{
                //如果页面有其他必填项没有填写，勾选订单模式点击确定按钮后，勾选的订单模式已经放到了submit_data中
                //如果此时取消勾选提交数据，虽然没有勾选订单模式，但是提交数据依然存储了值
                //那么submit_data中存在的数据没有清空，所以需要下面这行代码去清空
                _this.submit_data.order_mode = ''

            }

        },


        orderModeList() {
            // 请求公司管理接口获取公司唯一编码
            _this
                .$post('/order/orderModeLists', _this.mode_options_data)
                .then((res) => {


                    _this.options_order_code = res.data;
                })
                .catch((err) => {});
        },

        // 关闭方法
        closeDialog() {
            _this.show = false;

            _this.order_mode = [];
            _this.options_order_code = [];

            _this.mode_options_data = {
                page: 1,
                limit: 50,
                status: '1'
            };
            _this.submit_data = {
                name: '',
                amount: '',
                offline_pay: '',
                order_mode: '',
                end_time: '',
                num: ''
            };
        },

        // 提交
        onSubmitDig() {
            _this.$emit('onSubmit');
            _this.closeDialog();
        }
    }
};
</script>

<style scoped>
.el-icon-question {
    margin-left: 20px;
}
.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
    overflow-y: auto;
    height: calc(100vh - 100px);
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

.el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}

.avatar-uploader {
    width: 100px;
    height: 100px;
}
.item-wrap {
    margin-bottom: 10px;
}
</style>
